import { render, staticRenderFns } from "./MobileNavBar.vue?vue&type=template&id=824f7a60&scoped=true&"
import script from "./MobileNavBar.vue?vue&type=script&lang=js&"
export * from "./MobileNavBar.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavBar.vue?vue&type=style&index=0&id=824f7a60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824f7a60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Plus: require('/vercel/path0/components/icons/Plus.vue').default,SrfLogo: require('/vercel/path0/components/icons/SrfLogo.vue').default,Container: require('/vercel/path0/components/ui/Container.vue').default})
